import React from 'react';
import { Link } from 'react-router';
import { Form, Field } from 'react-final-form';
import { FormGroup, Button } from 'react-bootstrap';
import { required } from '../../../forms';
import InputWithLabel from '../../../forms/InputWithLabel';

const LoginForm = ({ onSubmit, initialValues, options, handleShowTermsAndCondition, handleShowPrivacyPolicy }) => (
  <Form
    onSubmit={onSubmit}
    initialValues={initialValues}
    validate={values => {
      const errors = {};
      if (!values.email) {
        errors.email = 'Please enter your email address';
      }
      return errors;
    }}
    render={({ handleSubmit, submitting, pristine, errors }) => (
      <div>
        <form onSubmit={handleSubmit}>
          <FormGroup>
            <Field
              label="Email Address"
              name="email"
              type="text"
              component={InputWithLabel}
              placeholder="email"
              validate={required}
            />
            <Field
              label="Password"
              name="password"
              type="password"
              placeholder="Password"
              component={InputWithLabel}
              validate={required}
            />

            <Field
              name="is_terms_accepted"
              type="checkbox"
              component="input"
            />

            I accept the <a onClick={handleShowTermsAndCondition}>Terms of Use</a> and
            <a onClick={handleShowPrivacyPolicy}> Privacy Policy.</a>

          </FormGroup>
          <br />
          <FormGroup>
            <p className="center-text primary login-link">
              <Link to="/login/recover/">Forgot your password?</Link>
            </p>
            <Button disabled={pristine || submitting} bsStyle="default" type="submit">
              Log In
            </Button>
          </FormGroup>
        </form>
      </div>
    )}
  />
);

export default LoginForm;



// WEBPACK FOOTER //
// src/routes/login/containers/LoginForm.js